import React, { useState, useContext, useEffect } from 'react';
import { useImmer } from 'use-immer'
import _ from 'lodash';
import { Card, Button, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import ReactPaginate from 'react-paginate';
import { CustomerAccountService } from '../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faChevronCircleRight, faCircle } from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from '../../contexts/AuthContext';
import { useHistory } from 'react-router';


const pageSize = 10;

//const ParentAccountListItem = (account) => {
//    return (
//        <>
//            <tr key={account.id}>
//                <td className="table-fit">{account.id}</td>
//                <td>{account.name}</td>
//                <td>Parent Account</td>
//                <td></td>
//                <td>{account.emrVendor}</td>
//                <td className="table-fit">
//                    <LinkContainer to={'accounts/' + account.id}>
//                        <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
//                    </LinkContainer>
//                </td>
//            </tr>
//            {
//                account.childAccounts.map((acc) => AccountListItem(acc, true))
//            }
//        </>
//    )
//}

//const AccountListItem = (account, isChild) => {
//    const queueArray = [];
//    if (account.homecareQueueId > 0) {
//        queueArray = 
//    }
//    return (
//        <tr key={account.id}>
//            {
//                isChild ?
//                    <td className="table-fit">&nbsp;<b>-</b>&nbsp;&nbsp;{account.id}</td> :
//                    <td className="table-fit">{account.id}</td>
//            }

//            <td>{account.name} </td>
//            <td>{account.isParentAccount ? 'Parent Account' : account.parentAccountId !== null ? 'Child Account' : 'Account'}</td>
//            <td>{account.parentAccountName}</td>
//            <td>{account.emrVendor}</td>
//            <td className="table-fit">
//                <LinkContainer to={'accounts/' + account.id}>
//                    <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
//                </LinkContainer>
//            </td>
//        </tr>
//    )
//}

const Customers = (props) => {
    const [accounts, setAccounts] = useImmer([]);
    const [viewModel, setViewModel] = useImmer({ vendors: [], queues: [] });
    const [pagedAccounts, setPagedAccounts] = useImmer([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [searchText, setSearchText] = useImmer('');
    const [canCreate, setCanCreate] = useState(false);

    const authContext = useContext(AuthContext);

    const history = useHistory();

    useEffect(() => {
        const values = [authContext.claimValues.createReadUpdateDelete];
        const canCreate = authContext.hasPermission(authContext.claims.canCrudAccounts, values);
        setCanCreate(canCreate);
        getCustomers();
    }, [])

    useEffect(() => {

    }, [authContext.currentUser])

    useEffect(() => {
        filterResults();
    }, [searchText])

    const getCustomers = async () => {
        var customerService = new CustomerAccountService();
        var callResult = await customerService.getCustomers();
        if (callResult.result) {
            let localAccounts = filterSort(callResult.model.accounts);
            setAccounts(localAccounts);
            setViewModel(_.omit(callResult.model, "accounts"));
            setPagedAccounts(_.chunk(localAccounts, pageSize))
            setCurrentPage(0);
        } else {
            // show some kind of error???
        }
    }

    const createNewCustomer = async (customer) => {
        var customerService = new CustomerAccountService();
        var result = await customerService.createCustomer(customer);
        if (result.result) {
            authContext.hideModal();
            history.push({
                pathname: `/admin/accounts/${result.model.id}`
            })
        }
        else {
            return result;
        }
    }

    const filterSort = (accounts) => {
        var sorted = accounts.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
        return sorted;
    }

    const filterResults = () => {
        const search = searchText.toLowerCase();

        // filter main results
        let filteredData = accounts.filter(account => account.name.toLowerCase().includes(search));
        filteredData = filterSort(filteredData);

        // chunk those results into pages
        const pagedResults = _.chunk(filteredData, pageSize);

        // update state
        setPagedAccounts(pagedResults);
        setCurrentPage(0);
    }



    const handleSearch = (e) => {
        const text = e.target.value;
        setSearchText(text);
    }

    const handlePage = (page) => {
        //var nextState = produce(this.state, draft => {
        //    draft.currentPage = page.selected;
        //})
        setCurrentPage(page.selected);
    }

    const renderCustomerTable = () => {
        return (
            <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th className="table-fit">Id</th>
                        <th>
                            <Form.Control value={searchText}
                                className="borderless-control"
                                name="searchText" id="searchText"
                                size="sm" placeholder="Account Name"
                                onChange={handleSearch} />
                        </th>
                        <th>Type</th>
                        <th>Parent Account</th>
                        <th>Vendor</th>
                        <th>Queues</th>
                        <th className="table-fit"></th>
                    </tr>
                </thead>
                <tbody>
                    {pagedAccounts[currentPage]?.map((account) =>
                        renderAccountListItem(account, false)
                        //account.isParentAccount && this.state.searchText.length == 0 ? ParentAccountListItem(account, false) : AccountListItem(account, false)
                        //<tr key={account.id}>
                        //    <td className="table-fit">{account.id}</td>
                        //    <td>{account.name}</td>
                        //    <td>{account.emrVendor}</td>
                        //    <td>{account.userCount}</td>
                        //    <td className="table-fit">
                        //        <LinkContainer to={'accounts/' + account.id}>
                        //            <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
                        //        </LinkContainer>
                        //    </td>
                        //</tr>
                    )}
                </tbody>
            </table>
        )
    };

    const renderAccountListItem = (account, isChild) => {
        const queueArray = [];
        if (account.homecareQueueId > 0) {
            queueArray.push(viewModel.queues.find(x => x.id == account.homecareQueueId)?.name);
        }
        if (account.hospiceQueueId > 0) {
            queueArray.push(viewModel.queues.find(x => x.id == account.hospiceQueueId)?.name);
        }
        const queueString = queueArray.join(', ');
        return (
            <tr key={account.id}>
                {
                    isChild ?
                        <td className="table-fit">&nbsp;<b>-</b>&nbsp;&nbsp;{account.id}</td> :
                        <td className="table-fit">{account.id}</td>
                }

                <td>{account.name} </td>
                <td>{account.isParentAccount ? 'Parent Account' : account.parentAccountId !== null ? 'Child Account' : 'Account'}</td>
                <td>{account.parentAccountName}</td>
                <td>{account.emrVendor}</td>
                <td>{queueString}</td>
                <td className="table-fit">
                    <LinkContainer to={'accounts/' + account.id}>
                        <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
                    </LinkContainer>
                </td>
            </tr>
        )
    };

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Accounts</div>
                <div className="card-btn-group">
                    <Button
                        variant="primary"
                        style={!canCreate ? { display: "none" } : null}
                        size="sm"
                        onClick={() => authContext.showModal({
                            open: true,
                            model: viewModel.vendors,
                            hideModal: authContext.hideModal,
                            saveModel: createNewCustomer
                        }, 'createCustomer')}>
                        Create
                        </Button>
                </div>
            </Card.Header>
            <Card.Body className="card-body-table">
                {renderCustomerTable()}
                {
                    pagedAccounts.length > 1 ?
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            //padding: 20,
                            boxSizing: 'border-box',
                            width: '100%',
                        }}>
                            <ReactPaginate
                                activeClassName={'pagination-item pagination-active '}
                                breakClassName={'pagination-item pagination-break-me '}
                                breakLabel={'...'}
                                containerClassName={'pagination-pagination'}
                                disabledClassName={'pagination-disabled-page'}
                                marginPagesDisplayed={2}
                                nextClassName={'pagination-item pagination-next '}
                                nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                                onPageChange={handlePage}
                                forcePage={currentPage}
                                pageCount={pagedAccounts.length}
                                pageClassName={'pagination-item pagination-page '}
                                pageRangeDisplayed={2}
                                previousClassName={'pagination-item pagination-previous'}
                                previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                            />
                        </div> : null
                }
            </Card.Body>
        </Card>
    );
}

export default Customers;

//class Customers2 extends Component {
//    constructor(props, context) {
//        super(props, context);
//        this.state = {
//            viewModel: {
//                accounts: [{ users: [] }],
//                vendors: [],
//                queues: []
//            },
//            pagedAccounts: [],
//            currentPage: 0,
//            searchText: '',
//            canCreate: false
//        };

//        this.createNewCustomer = this.createNewCustomer.bind(this);
//        this.filterSort = this.filterSort.bind(this);
//        this.filterResults = this.filterResults.bind(this);
//        this.handleSearch = this.handleSearch.bind(this);
//        this.handlePage = this.handlePage.bind(this);
//    }

//    componentDidMount() {
//        const values = [this.props.authValues.claimValues.createReadUpdateDelete];
//        const canCreate = this.props.hasPermission(this.props.authValues.claims.canCrudAccounts, values);
//        this.setState({ canCreate: canCreate }, () => this.getCustomers());
//    }

//    async getCustomers() {
//        var customerService = new CustomerAccountService();
//        var results = await customerService.getCustomers();
//        results.model.accounts = this.filterSort(results.model.accounts);
//        const pagedResults = _.chunk(results.model.accounts, pageSize);
//        this.setState({ viewModel: results.model, pagedAccounts: pagedResults, currentPage: 0 });
//    }

//    async createNewCustomer(customer) {
//        var customerService = new CustomerAccountService();
//        var result = await customerService.createCustomer(customer);
//        if (result.result) {
//            this.props.hideModal();
//            this.props.history.push({
//                pathname: `/admin/accounts/${result.model.id}`
//            })
//        }
//        else {
//            // show errors
//        }
//    }

//    filterSort(accounts) {
//        var sorted = accounts.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
//        return sorted;
//    }

//    filterResults() {
//        const search = this.state.searchText.toLowerCase();
//        const accounts = this.state.viewModel.accounts;

//        // filter main results
//        let filteredData = accounts.filter(account => account.name.toLowerCase().includes(search));
//        let childFilteredData = accounts.filter(account => account.childAccounts && account.childAccounts.length > 0);
//        childFilteredData = childFilteredData.flatMap(account => account.childAccounts);
//        childFilteredData = childFilteredData.filter(account => account.name.toLowerCase().includes(search));
//        filteredData = filteredData.concat(childFilteredData);
//        filteredData = this.filterSort(filteredData);

//        // chunk those results into pages
//        const pagedResults = _.chunk(filteredData, pageSize);

//        // update state
//        this.setState({ pagedAccounts: pagedResults, currentPage: 0 });
//    }

//    handleSearch(e) {
//        const text = e.target.value;
//        this.setState({ searchText: text }, () => this.filterResults());
//    }

//    handlePage(page) {
//        var nextState = produce(this.state, draft => {
//            draft.currentPage = page.selected;
//        })
//        this.setState(nextState);
//    }

//    renderCustomerTable() {
//        return (
//            <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
//                <thead>
//                    <tr>
//                        <th className="table-fit">Id</th>
//                        <th>
//                            <Form.Control value={this.state.searchText}
//                                className="borderless-control"
//                                name="searchText" id="searchText"
//                                size="sm" placeholder="Account Name"
//                                onChange={this.handleSearch} />
//                        </th>
//                        <th>Type</th>
//                        <th>Parent Account</th>
//                        <th>Vendor</th>
//                        <th>Queues</th>
//                        <th className="table-fit"></th>
//                    </tr>
//                </thead>
//                <tbody>
//                    {this.state.pagedAccounts[this.state.currentPage]?.map((account) =>
//                        this.renderAccountListItem(account, false)
//                        //account.isParentAccount && this.state.searchText.length == 0 ? ParentAccountListItem(account, false) : AccountListItem(account, false)
//                        //<tr key={account.id}>
//                        //    <td className="table-fit">{account.id}</td>
//                        //    <td>{account.name}</td>
//                        //    <td>{account.emrVendor}</td>
//                        //    <td>{account.userCount}</td>
//                        //    <td className="table-fit">
//                        //        <LinkContainer to={'accounts/' + account.id}>
//                        //            <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
//                        //        </LinkContainer>
//                        //    </td>
//                        //</tr>
//                    )}
//                </tbody>
//            </table>
//        )
//    };

//    renderAccountListItem(account, isChild) {
//        const queueArray = [];
//        if (account.homecareQueueId > 0) {
//            queueArray.push(this.state.viewModel.queues.find(x => x.id == account.homecareQueueId)?.name);
//        }
//        if (account.hospiceQueueId > 0) {
//            queueArray.push(this.state.viewModel.queues.find(x => x.id == account.hospiceQueueId)?.name);
//        }
//        const queueString = queueArray.join(', ');
//        return (
//            <tr key={account.id}>
//                {
//                    isChild ?
//                        <td className="table-fit">&nbsp;<b>-</b>&nbsp;&nbsp;{account.id}</td> :
//                        <td className="table-fit">{account.id}</td>
//                }

//                <td>{account.name} </td>
//                <td>{account.isParentAccount ? 'Parent Account' : account.parentAccountId !== null ? 'Child Account' : 'Account'}</td>
//                <td>{account.parentAccountName}</td>
//                <td>{account.emrVendor}</td>
//                <td>{queueString}</td>
//                <td className="table-fit">
//                    <LinkContainer to={'accounts/' + account.id}>
//                        <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
//                    </LinkContainer>
//                </td>
//            </tr>
//        )
//    };


//    render() {
//        return (
//            <Card>
//                <Card.Header className="d-flex align-items-center">
//                    <div className="mr-auto" >Accounts</div>
//                    <div className="card-btn-group">
//                        <Button
//                            variant="primary"
//                            style={!this.state.canCreate ? { display: "none" } : null}
//                            size="sm"
//                            onClick={() => this.props.showModal({
//                                open: true,
//                                model: this.state.viewModel.vendors,
//                                hideModal: this.props.hideModal,
//                                saveModel: this.createNewCustomer
//                            }, 'createCustomer')}>
//                            Create
//                        </Button>
//                    </div>
//                </Card.Header>
//                <Card.Body className="card-body-table">
//                    {this.renderCustomerTable()}
//                    {
//                        this.state.pagedAccounts.length > 1 ?
//                            <div style={{
//                                display: 'flex',
//                                flexDirection: 'column',
//                                justifyContent: 'center',
//                                //padding: 20,
//                                boxSizing: 'border-box',
//                                width: '100%',
//                            }}>
//                                <ReactPaginate
//                                    activeClassName={'pagination-item pagination-active '}
//                                    breakClassName={'pagination-item pagination-break-me '}
//                                    breakLabel={'...'}
//                                    containerClassName={'pagination-pagination'}
//                                    disabledClassName={'pagination-disabled-page'}
//                                    marginPagesDisplayed={2}
//                                    nextClassName={'pagination-item pagination-next '}
//                                    nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
//                                    onPageChange={this.handlePage}
//                                    forcePage={this.state.currentPage}
//                                    pageCount={this.state.pagedAccounts.length}
//                                    pageClassName={'pagination-item pagination-page '}
//                                    pageRangeDisplayed={2}
//                                    previousClassName={'pagination-item pagination-previous'}
//                                    previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
//                                />
//                            </div> : null
//                    }
//                </Card.Body>
//            </Card>
//        );
//    }

//}

//export connect(null, dispatch => bindActionCreators({ ...modalActionCreator }, dispatch))(Customers2);